import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {ConsignmentUtils} from "../../../consignment.utils";
import {IE3CL745, IE3SupplementaryDeclarant} from "@portbase/bezoekschip-service-typescriptmodels";
import lodash, {cloneDeep} from "lodash";
import {HandleQuery} from "../../../../../common/handlers/handle-query";
import {Observable} from "rxjs";
import {ErrorWithPointers} from "../../../../../common/errors/errors";
import {map} from "rxjs/operators";
import {Handler} from "../../../../../common/handlers/handler";
import {View} from "../../../../../common/handlers/view";

@Component({
    selector: 'app-consignment-supplementary-declarant',
    templateUrl: './consignment-supplementary-declarant.component.html',
    styleUrls: ['./consignment-supplementary-declarant.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Handler()
export class ConsignmentSupplementaryDeclarantComponent extends View implements OnInit {
  portVisitUtils = PortvisitUtils;
  utils = ConsignmentUtils;

  @Input() label: string;
  @Input() supplementaryDeclarant: IE3SupplementaryDeclarant;
  @Input() supplementaryFilingType: string;
  @Input() required: boolean;

  private _editMode: boolean;
  declarantEditMode: boolean;
  backupSupplementaryDeclarant: IE3SupplementaryDeclarant;

  @Output() supplementaryDeclarantChange: EventEmitter<IE3SupplementaryDeclarant> = new EventEmitter<IE3SupplementaryDeclarant>();

  @Input() set editMode(value: boolean) {
    this._editMode = value;
    if (this._editMode) {
      this.supplementaryDeclarant = this.supplementaryDeclarant || this.newSupplementaryDeclarant();
    }
  }

  ngOnInit(): void {
    this.declarantEditMode = this.editMode;
  }

  get editMode() {
    return this._editMode;
  }

  toggleEditMode = () => {
    this.declarantEditMode = !this.declarantEditMode;
    if (this.declarantEditMode) {
      this.backupSupplementaryDeclarant = cloneDeep(this.supplementaryDeclarant);
    }
  }

  cancel = () => {
    this.supplementaryDeclarant = this.backupSupplementaryDeclarant;
    this.toggleEditMode();
  }

  save = () => {
    this.toggleEditMode();
    this.supplementaryDeclarantChange.emit(this.supplementaryDeclarant);
  }

  newSupplementaryDeclarant = (): IE3SupplementaryDeclarant => {
    var defaultType;
    switch (this.supplementaryFilingType) {
      case "N1" :defaultType = IE3CL745.N1;break;
      case "N2" :defaultType = IE3CL745.N2;
    }
    const newSupplementaryDeclarant: IE3SupplementaryDeclarant = {
      supplementaryFilingType: defaultType,
      identificationNumber: null
    };
    newSupplementaryDeclarant["isNewRecord"] = true;
    return newSupplementaryDeclarant;
  }

  @HandleQuery("getErrors")
  getErrors(): Observable<ErrorWithPointers[]> {
    return this.sendQuery("getConsignmentErrors")
      .pipe(map((e: ErrorWithPointers[]) => {
        const predicate = p => p.model === this.supplementaryDeclarant;
        return e.filter(p => p.pointers.some(predicate))
          .map(e => ({
            ...e,
            pointers: lodash.drop(e.pointers, lodash.findIndex(e.pointers, predicate))
          }));
      }));
  }
}
